/**
 * Right
 */
export class Right {
  /**
   * Value
   */
  enabled: string;

  /**
   * User
   */
  user: string;

  /**
   * Module
   */
  module: string;

  /**
   * Right
   */
  right: string;

  /**
   * Constructor
   *
   * @param value Value
   * @param user User
   * @param module Module
   * @param right Right
   */
  constructor(value?: string, user?: string, module?: string, right?: string) {
    this.enabled = value;
    this.user = user;
    this.module = module;
    this.right = right;
  }

  /**
   * Create from json
   *
   * @param json Json with data
   *
   * @return self
   */
  static createFromJson(json: object): Right {
    const self = new this();

    Object.keys(self).forEach((key) => {
      self[key] = json[key];
    });

    return self;
  }

  get isEnabled(): boolean {
    return this.enabled.toUpperCase() === 'SI';
  }
}
